import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { courseFinanceCategoriesApi } from "./courseFinanceCategoriesApi";

export const useCourseFinanceCategories = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_FINANCES_CATEGORIES(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => courseFinanceCategoriesApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_FINANCES_CATEGORIES(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, categories: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export const useCourseFinanceCategoryOptions = (isSystem?: boolean) => {
  const filter = isSystem ? "isSystem eq '1'" : "";
  const { isLoading, categories } = useCourseFinanceCategories(0, 1_000_000, "", filter);

  const options = categories.map((x) => ({
    value: x.id.toString(),
    label: x.name,
  }));

  return { loading: isLoading, options };
};
